<script lang="ts">
	import type { PageProps } from "./$types";
	import { BlogPostArticle } from "#lib/web-ui/blocks/blog/index.js";

	let { data }: PageProps = $props();
</script>

<BlogPostArticle
	post={data.post}
	siteName="Fergmar Capital"
	siteUrl="https://fergmarcapital.com"
	blogListUrl="/media/blog"
/>
